import { ISbResult } from "storyblok-js-client";
import { Post } from "@/types/Post";

export const mapResultToPosts = (result: ISbResult) => ({
  posts: result.data.stories.map((s: any) => new Post(s)),
  totalPages: Math.ceil(result.total / result.perPage),
});
